var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.5 1.75C6.98122 1.75 5.75 2.98122 5.75 4.5V5.75H4.5C2.98122 5.75 1.75 6.98122 1.75 8.5V15.5C1.75 17.0188 2.98122 18.25 4.5 18.25H11.5C13.0188 18.25 14.25 17.0188 14.25 15.5V14.25H15.5C17.0188 14.25 18.25 13.0188 18.25 11.5V4.5C18.25 2.98122 17.0188 1.75 15.5 1.75H8.5ZM14.25 12.75H15.5C16.1904 12.75 16.75 12.1904 16.75 11.5V4.5C16.75 3.80964 16.1904 3.25 15.5 3.25H8.5C7.80964 3.25 7.25 3.80964 7.25 4.5V5.75H11.5C13.0188 5.75 14.25 6.98122 14.25 8.5V12.75ZM3.25 8.5C3.25 7.80964 3.80964 7.25 4.5 7.25H11.5C12.1904 7.25 12.75 7.80964 12.75 8.5V15.5C12.75 16.1904 12.1904 16.75 11.5 16.75H4.5C3.80964 16.75 3.25 16.1904 3.25 15.5V8.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.a4f196f45f6f8c76a174fc07a31f623c.svg";
export { ForwardRef as ReactComponent };